<div class="select-container" [id]="uniqueId">
    <div class="custom-select" [ngClass]="{'open-dropdown': openDropdown, 'error': error, 'multiple': multiple}"
        [ngStyle]="styles" (click)="toggleDropdown()">
        <div class="span-ellipsis" *ngIf="!loading && !showOtherOptionInput">
            <span *ngIf="translateKey && !multiple && (selectedKey || selectedKey === 0)">
                {{ translateKey + selectedKey | translate
                }}
            </span>
            <span *ngIf="!translateKey && !multiple && (selectedKey || selectedKey === 0)">
                {{ selectedKey }}
            </span>
            <div class="selected-text-container" *ngIf="multiple && selectedKeys.length > 0">
                <p>{{ selectedKeys.length }} {{ selectedText }}</p>
                <img (click)="clearSelection($event)" class="close-icon" src="../../../../assets/icons/x.svg" alt="">
            </div>
            <span [hidden]="(!multiple && (selectedKey || selectedKey === 0)) || (multiple && selectedKeys.length > 0)"
                class="placeholder-select">
                {{ placeholder }}
            </span>
        </div>

        <div class="span-ellipsis" *ngIf="showOtherOptionInput && !loading">
            <span>{{otherOptionKey | translate}}</span>
        </div>

        <div class="span-ellipsis" *ngIf="loading">
            <span class="placeholder-select ">
                {{'Loading' | translate}}
            </span>
        </div>

        <div class="chevron" [class.open]="openDropdown"></div>
    </div>
    <div class="options-container" [ngClass]="{'absolute': showAbsolute, 'multiple-dropdown': multiple}"
        *ngIf="openDropdown">
        <div class="no-options" *ngIf="!dataArray || dataArray.length == 0">{{ noOptionsText }}</div>
        <div class="options-scroll" *ngIf="dataArray && dataArray.length > 0">
            <div *ngFor="let type of dataArray; let last = last">
                <div (click)="selectOption($event, type)"
                    [ngClass]="(isSelected(type) ? 'selected-option' : 'option') + (multiple ? ' multiple' : '')"
                    [attr.aria-selected]="isSelected(type)">
                    <span class="option-text">{{ translateKey + type | translate }}</span>
                    <input *ngIf="multiple" type="checkbox" class="checkbox-square" [checked]="selectedKeys.includes(type)" readonly />

                    <img *ngIf="!multiple && isSelected(type)"
                        src="../../../../../../../../assets/icons/solid_check.webp" alt="Check Icon" loading="lazy">
                </div>
                <div class="split-option" *ngIf="!last"></div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="otherOption && showOtherOptionInput" class="mg-t15">
    <input id="Mileage" [(ngModel)]="otherOptionText" (ngModelChange)="setOtherOptionText(otherOptionText)"
        class="form-text-input" [placeholder]=" 'Type' | translate" type="text">
</div>